import { render, staticRenderFns } from "./AlternativeProduct.vue?vue&type=template&id=e0e52e7e&scoped=true&"
import script from "./AlternativeProduct.vue?vue&type=script&lang=ts&"
export * from "./AlternativeProduct.vue?vue&type=script&lang=ts&"
import style0 from "./AlternativeProduct.vue?vue&type=style&index=0&id=e0e52e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e52e7e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsKELabel: require('/var/www/packages/theme/components/atoms/KELabel.vue').default,AtomsFavoriteButton: require('/var/www/packages/theme/components/atoms/FavoriteButton.vue').default,AtomsRatingStarsBar: require('/var/www/packages/theme/components/atoms/RatingStarsBar.vue').default,AtomsAddToCartButton: require('/var/www/packages/theme/components/atoms/AddToCartButton.vue').default,AtomsPrice: require('/var/www/packages/theme/components/atoms/Price.vue').default})
